import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("已处理")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("未处理")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatFullTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { 
  // 分页查询
  'POST/cost_cash_packs/advance/page': fetchList,
  // 删除
  'DELETE/cost_cash_packs/advance/{id}': delApi,
  // 更新
  'POST/cost_cash_packs/advance/update': updateApi,
  // 新增
  'POST/cost_cash_packs/advance/add': addApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchEle = ref()
const searchObj = reactive({
  dataType: '',
})
const searchHandle = () => {
  fetchData(searchObj)
}
searchHandle()
const resetform=(formEl:any)=>{
  if(!formEl) return
  formEl.resetFields()
  searchHandle()
}
// 添加
const isShowAdd = ref<boolean>(false)
const addObj = reactive({
  resourceId: '',
  taskId: '',
})
const ShowAddHandle = () => {
  addObj.resourceId = ''
  addObj.taskId = ''
  isShowAdd.value = true
}
const submitAdd = () => {
  if(!addObj.resourceId){
    ElMessage.warning('请输入译员ID')
    return
  }
  addApi(addObj).then(() => {
    MI_identify.value = false
    searchHandle()
    ElMessage.success('新增成功')
    isShowAdd.value = false
  }).finally(() => {
    MI_identify.value = false
  })
}

// 更新
const isShowEdit = ref<boolean>(false)
const editObj = reactive({
  id: '', notes: '',
})
const modifyHandle = (row: any) => {
  editObj.id = row.id
  editObj.notes = row.notes
  isShowEdit.value = true
}
const submitEidt = () => {
  updateApi(editObj).then(() => {
    MI_identify.value = false
    searchHandle()
    ElMessage.success('更新成功')
    isShowEdit.value = false
  }).finally(() => {
    MI_identify.value = false
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm('请确认是否删除', '提示', {type: 'warning'}).then(() => {
    MI_identify.value = true
    return delApi({id: row.id})
  }).then(() => {
    MI_identify.value = false
    searchHandle()
    ElMessage.success('删除成功')
  }).finally(() => {
    MI_identify.value = false
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "预付款-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: _unref(searchObj),
              "label-width": "auto",
              inline: "",
              class: "searchBg",
              ref_key: "searchEle",
              ref: searchEle
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "译员ID:",
                  prop: "resourceId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: _unref(searchObj).resourceId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).resourceId) = $event)),
                      placeholder: "请输入译员ID",
                      clearable: "",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "任务ID:",
                  prop: "taskId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: _unref(searchObj).taskId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).taskId) = $event)),
                      placeholder: "请输入任务ID",
                      clearable: "",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "预付提现ID:",
                  prop: "costId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: _unref(searchObj).costId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).costId) = $event)),
                      placeholder: "请输入预付提现ID",
                      clearable: "",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "备注:",
                  prop: "notes"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: _unref(searchObj).notes,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).notes) = $event)),
                      placeholder: "请输入备注",
                      clearable: "",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "预付提现支付包:",
                  prop: "packName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: _unref(searchObj).packName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).packName) = $event)),
                      placeholder: "请输入预付提现支付包",
                      clearable: "",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "正常提现ID:",
                  prop: "normalCostId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: _unref(searchObj).normalCostId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).normalCostId) = $event)),
                      placeholder: "请输入正常提现ID",
                      clearable: "",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "正常提现支付包:",
                  prop: "normalPackName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      modelValue: _unref(searchObj).normalPackName,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).normalPackName) = $event)),
                      placeholder: "请输入正常提现支付包",
                      clearable: "",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "处理状态",
                  prop: "status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).status,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchObj).status) = $event)),
                      placeholder: "请选择处理状态",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "已处理",
                          value: "processed"
                        }),
                        _createVNode(_component_el_option, {
                          label: "未处理",
                          value: "pending_processing"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "类型",
                  prop: "dataType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).dataType,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchObj).dataType) = $event)),
                      placeholder: "请选择类型",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "识别预付",
                          value: "SYSTEM_SCAN"
                        }),
                        _createVNode(_component_el_option, {
                          label: "手动新增",
                          value: "MANUAL_ADD"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (resetform(searchEle.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (searchHandle()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[11] || (_cache[11] = ($event: any) => (ShowAddHandle())),
      type: "primary",
      class: "mt-10 mb-10"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 70 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "译员ID",
          prop: "resourceId"
        }),
        _createVNode(_component_el_table_column, {
          label: "任务ID",
          prop: "taskId"
        }),
        _createVNode(_component_el_table_column, {
          label: "预付提现ID",
          prop: "costId"
        }),
        _createVNode(_component_el_table_column, {
          label: "预付提现支付包",
          prop: "packName"
        }),
        _createVNode(_component_el_table_column, {
          label: "正常提现ID",
          prop: "normalCostId"
        }),
        _createVNode(_component_el_table_column, {
          label: "正常提现支付包",
          prop: "normalPackName"
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "notes",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "是否处理",
          prop: "status",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (row.status === 'processed')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "类型",
          prop: "type",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "创建时间",
          prop: "createTime",
          formatter: _unref(formatFullTime),
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (modifyHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[13] || (_cache[13] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      "page-sizes": [30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAdd.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((isShowAdd).value = $event)),
      title: "新增",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[16] || (_cache[16] = ($event: any) => (isShowAdd.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitAdd
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _unref(addObj),
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "任务ID:",
              prop: "taskId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addObj).taskId,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(addObj).taskId) = $event)),
                  placeholder: "请输入任务ID",
                  maxlength: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "译员ID:",
              prop: "resourceId",
              rules: [{ required: true, message: '请输入译员ID', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addObj).resourceId,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(addObj).resourceId) = $event)),
                  placeholder: "请输入译员ID",
                  maxlength: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowEdit.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((isShowEdit).value = $event)),
      title: "更新",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[19] || (_cache[19] = ($event: any) => (isShowEdit.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitEidt
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _unref(editObj).notes,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(editObj).notes) = $event)),
          placeholder: "请更新备注",
          maxlength: "300",
          type: "textarea"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})